import React, { useState, useCallback, createContext, useContext } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const addToast = useCallback((message, type = 'info', duration = 3000) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    // duration が falsy (null/0) のトーストは自動消去しない。手動 (×) で閉じるまで残す。
    if (duration) {
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, duration);
    }
  }, []);

  const toast = {
    success: (msg) => addToast(msg, 'success'),
    // エラーは自動で消さない。内容を確認・スクショして報告できるよう、× で手動クローズ。
    error: (msg) => addToast(msg, 'error', null),
    info: (msg) => addToast(msg, 'info'),
  };

  const typeBg = (type) => {
    switch (type) {
      case 'success': return 'bg-emerald-600';
      case 'error':   return 'bg-red-600';
      default:        return 'bg-blue-600';
    }
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div
        role="status"
        aria-live="polite"
        className="fixed top-5 right-5 z-[9999] flex flex-col gap-2 pointer-events-none"
      >
        {toasts.map(t => (
          <div
            key={t.id}
            className={`px-5 py-3 rounded-lg text-white min-w-[280px] max-w-[420px] shadow-lg pointer-events-auto flex items-start gap-3 ${typeBg(t.type)}`}
            style={{ animation: 'toast-in 0.3s ease' }}
          >
            <span className="flex-1 whitespace-pre-wrap break-words">{t.message}</span>
            <button
              type="button"
              onClick={() => removeToast(t.id)}
              aria-label="閉じる"
              className="bg-transparent border-0 p-0 rounded-none text-white/80 hover:text-white text-lg leading-none shrink-0"
            >×</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
